import React, { useEffect, useState, useContext } from "react";
import { Modal, Form, Row, Col, Button, Spinner } from "react-bootstrap";
import { formatDateYYYY_MM_DD, getCurrentDateTime } from "../../functions/common-functions";
import Swal from "sweetalert2";
import axios from "axios";
import withReactContent from "sweetalert2-react-content";
import { AuthContext } from "../../contexts/AuthContext";
import successImage from "../../icons/success-tick-logo.svg";
import errorImage from "../../icons/error-tick-logo.svg";
import SingleValuePopUp from "../utils/SingleValuePopUp";
import { BiSelectMultiple } from "react-icons/bi";
import { getAllActiveLocations } from "../../services/location-master-service";
import { addEnquiryTender, getAllEnquiryTenders } from "../../services/enquiry-tender-service";
import { getAllUOM } from "../../services/disposal-intimation-service";
import { getPresignedURL } from "../../functions/upload";
import { ALERT_PARAMS } from "../../utils/constant";
import Validate from "../utils/Validation";
import SearchSelect from "../common/SearchSelect";
import DragDropRender from "../utils/DragDropRender";
import { addLogDetails } from "../../services/logger-entry-service";

const AddEditEnquiryTender = (props) => {
    const MySwal = withReactContent(Swal);
    const context = useContext(AuthContext);
    const userDetails = {
        userName: context.userName,
        userId: context.userId,
    };

    const [loading, setLoading] = useState(false);
    const [showPopup, setShowPopup] = useState(false);
    const todayDate = getCurrentDateTime("/");

    const [enquiryObj, setEnquiryObj] = useState({
        EnquirySourceNumber: "-",
        EnquirySource: "Manual",
        EnquiryStatus: "Created",
        ItemCode: "",
        ItemDescription: "",
        ItemDetail: "",
        ItemType: "",
        Quantity: "",
        UOM: "",
        GST: "",
        Location: "",
        Division: "",
        LogisticCompany: "",
        ImagesAttachment: "",
        ImagesAttachmentFile: null,
        Remarks: "",
        DueDate: "",
        InsertedBy: userDetails.userId,
        InsertedByName: userDetails.userName,
        InsertedOn: todayDate,
        ModifiedBy: userDetails.userId,
        ModifiedByName: userDetails.userName,
        ModifiedOn: todayDate,
        Flag: "Active"
    });

    const [error, setError] = useState({
        // ItemCode: "",
        ItemDescription: "",
        ItemDetail: "",
        Quantity: "",
        UOM: "",
        GST: "",
        Location: "",
        Division: "",
        LogisticCompany: ""
    });

    const [locationList, setLocationList] = useState([]);
    const [uomList, setUomList] = useState([]);
    const [divisionList, setDivisionList] = useState([]);

    useEffect(() => {
        fetchLocations();
        fetchUOM();
        fetchDivisions();
    }, []);

    useEffect(() => {
        if (props.rowData && (props.action === "Edit" || props.action === "View")) {
            setEnquiryObj({
                ...props.rowData,
                DueDate: props.rowData.DueDate ? formatDateYYYY_MM_DD(new Date(props.rowData.DueDate)) : ""
            });
        }
    }, [props.rowData, props.action]);

    const fetchUOM = async () => {
        try {
            const uoms = await getAllUOM();
            setUomList(uoms.filter(uom => uom.DeleteIndication));
        } catch (error) {
            console.error("Error fetching UOMs:", error);
            setUomList([]);
        }
    };

    const fetchLocations = async () => {
        try {
            const locations = await getAllActiveLocations();
            setLocationList(locations);
        } catch (error) {
            console.error("Error fetching locations:", error);
            setLocationList([]);
        }
    };

    const fetchDivisions = async () => {
        try {
            const { getDivisions } = await import("../../services/user-service");
            const divisions = await getDivisions();
            setDivisionList(divisions);
        } catch (error) {
            console.error("Error fetching divisions:", error);
            setDivisionList([]);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        console.log("handlechange", name)

        if (name === "ItemDescription") {
            const allowedChars = /^[a-zA-Z0-9 .]*$/;
            if (!allowedChars.test(value) || value.length > 100) return;
        }

        if (name === "ItemDetail" || name === "Remarks") {
            const allowedChars = /^[a-zA-Z0-9 .]*$/;
            if (!allowedChars.test(value) || value.length > 250) return;
        }

        if (name === "Quantity") {
            const asPerWeight = "As Per Weight";
            // Allow empty or exact phrase
            if (value === "" || value === asPerWeight) {
            } else if (asPerWeight.startsWith(value)) {  // Allow partial typing of "As Per Weight"
            } else if (/^\d*\.?\d{0,2}$/.test(value)) { // Allow numeric with up to 2 decimals
            } else {
                return;
            }
        }

        if (name === "GST") {
            if (value === '' || /^\d+(\.\d{0,2})?$/.test(value) && parseFloat(value) <= 100) {
                if (value.length > 5) return;
            } else {
                return;
            }
        }

        if (name === "Location") {
            const allowedChars = /^[a-zA-Z0-9 ]*$/;
            if (!allowedChars.test(value) || value.length > 50) return;
        }

        if (name === "LogisticCompany") {
            const numericRegex = /^[0-9]*$/;
            if (!numericRegex.test(value) || value.length > 4) return;
        }

        const updates = { [name]: value };
        if (name === "DueDate" && props.action === "Edit" && value !== props.rowData?.DueDate) {
            updates.MailStatus = "Pending";
        }

        setEnquiryObj((prevState) => ({
            ...prevState,
            ...updates
        }));

        if (error[name]) {
            setError((prevState) => ({
                ...prevState,
                [name]: ""
            }));
        }
    };

    const handleDateBlur = (e) => {
        const { value } = e.target;
        const today = formatDateYYYY_MM_DD(new Date());
        if (value && value < today) {
            MySwal.fire({
                text: "Due Date cannot be a past date",
                imageUrl: errorImage,
                customClass: "swal-error",
            });
            setEnquiryObj((prevState) => ({
                ...prevState,
                DueDate: ""
            }));
        }
    };

    const validateDetails = () => {
        let isError = false;
        const errorMsg = { ...error };

        // if (!enquiryObj.ItemCode.trim()) {
        //     isError = true;
        //     errorMsg.ItemCode = "Item code is required";
        // }

        if (!enquiryObj.ItemDescription.trim()) {
            isError = true;
            errorMsg.ItemDescription = "Item description is required";
        }

        if (!enquiryObj.ItemDetail.trim()) {
            isError = true;
            errorMsg.ItemDetail = "Item detail is required";
        }

        if (!enquiryObj.Quantity.trim()) {
            isError = true;
            errorMsg.Quantity = "Quantity is required";
        }

        if (!enquiryObj.UOM.trim()) {
            isError = true;
            errorMsg.UOM = "UOM is required";
        }

        if (!enquiryObj.GST || parseFloat(enquiryObj.GST) < 0) {
            isError = true;
            errorMsg.GST = "Valid GST% is required";
        }

        if (!enquiryObj.Location.trim()) {
            isError = true;
            errorMsg.Location = "Location is required";
        }

        if (!enquiryObj.Division?.trim()) {
            isError = true;
            errorMsg.Division = "Division is required";
        }

        if (!enquiryObj.LogisticCompany?.trim()) {
            isError = true;
            errorMsg.LogisticCompany = "Logistic Company is required";
        }

        setError(errorMsg);
        return isError;
    };

    const handleChangeStatus = async (files, fieldName) => {
        const newFile = files[0];
        if (!newFile) return;

        const maxFileSize = 20 * 1024 * 1024;
        const validationError = Validate(newFile, "imgFormats", maxFileSize);
        if (validationError) {
            MySwal.fire({
                text: validationError,
                imageUrl: errorImage,
                customClass: "swal-success",
            });
            return;
        }

        setEnquiryObj((prevState) => ({
            ...prevState,
            [fieldName]: newFile.name,
            [`${fieldName}File`]: newFile,
        }));
    };

    const handleDeleteDocument = (fieldName) => {
        setEnquiryObj((prevState) => ({
            ...prevState,
            [fieldName]: "",
            [`${fieldName}File`]: null,
        }));
    };

    const uploadFile = async (signedURL, file) => {
        try {
            if (signedURL && file) {
                await axios.put(signedURL, file, {
                    headers: {
                        'Content-Type': file.type,
                    },
                });
            }
            return "";
        } catch (error) {
            console.error("File upload error:", error);
            return error;
        }
    };

    const handleSubmit = async (e) => {

        e.preventDefault();

        if (!validateDetails()) {
            const isEdit = props.action === "Edit";
            MySwal.fire({
                text: `Are you sure, do you want to ${isEdit ? "Update" : "Submit"} Enquiry/Tender?`,
                confirmButtonText: isEdit ? "Update" : "Submit",
                title: `${isEdit ? "Update" : "Submit"} Enquiry/Tender`,
                ...ALERT_PARAMS,
            }).then(async (result) => {
                if (result.isConfirmed) {
                    setLoading(true);

                    try {
                        let enquiryNumber;
                        let submissionData = {};
                        const todayDate = getCurrentDateTime("/");

                        if (isEdit) {
                            enquiryNumber = enquiryObj.EnquiryNumber;
                            const hadDueDate = props.rowData?.DueDate;
                            const hasDueDate = enquiryObj.DueDate;
                            const shouldChangeStatus = !hadDueDate && hasDueDate;

                            submissionData = {
                                ...enquiryObj,
                                EnquiryStatus: shouldChangeStatus ? "Not Assigned" : enquiryObj.EnquiryStatus,
                                ModifiedBy: userDetails.userId,
                                ModifiedByName: userDetails.userName,
                                ModifiedOn: todayDate,
                                DueDateFlag: enquiryObj.EnquiryStatus === "Live" ? "Active" : "Inactive",
                            };
                        } else {
                            enquiryNumber = await generateEnquiryNumber();
                            submissionData = {
                                ...enquiryObj,
                                EnquiryStatus: enquiryObj.DueDate ? "Not Assigned" : "Created",
                                EnquiryNumber: enquiryNumber,
                                PK: "EnquiryTender",
                                SK: "EnquiryNumber#" + enquiryNumber,
                                DueDateFlag: enquiryObj.EnquiryStatus === "Live" ? "Active" : "Inactive",
                            };
                        }

                        // Handle file upload
                        const fileObj = enquiryObj.ImagesAttachmentFile;
                        if (fileObj && fileObj instanceof File) {
                            try {
                                const filename = fileObj.name;
                                const signedURL = await getPresignedURL(
                                    `EnquiryTender/${enquiryNumber.replace(/\//g, '_')}/${filename}`
                                );
                                if (signedURL) {
                                    const uploadResult = await uploadFile(signedURL, fileObj);
                                    if (!uploadResult) {
                                        submissionData.ImagesAttachment = filename;
                                    } else {
                                        submissionData.ImagesAttachment = "";
                                    }
                                }
                            } catch (fileError) {
                                console.error("Error uploading file:", fileError);
                                submissionData.ImagesAttachment = "";
                            }
                        } else if (typeof enquiryObj.ImagesAttachment === 'string' && enquiryObj.ImagesAttachment) {
                            submissionData.ImagesAttachment = enquiryObj.ImagesAttachment;
                        }

                        const result = await addEnquiryTender(submissionData);

                        if (result.status) {
                            await addLogDetails(submissionData, isEdit ? "Edit" : "Add", enquiryNumber, "EnquiryTenderLog", userDetails, "Transaction");

                            setLoading(false);
                            MySwal.fire({
                                text: isEdit
                                    ? `Enquiry/Tender updated successfully. Enquiry Number: ${enquiryNumber}`
                                    : `Enquiry/Tender submitted successfully. Enquiry Number: ${enquiryNumber}`,
                                imageUrl: successImage,
                                customClass: "swal-success"
                            });

                            props.onHide();
                            props.setReload(!props.reload);
                        } else {
                            setLoading(false);
                            MySwal.fire({
                                text: result.message,
                                imageUrl: errorImage,
                                customClass: "swal-success"
                            });
                        }
                    } catch (error) {
                        setLoading(false);
                        MySwal.fire({
                            text: "Unable to process request",
                            imageUrl: errorImage,
                            customClass: "swal-success"
                        });
                    }
                }
            });
        }
    };

    const generateEnquiryNumber = async () => {
        const currentDate = new Date();
        const currentYear = currentDate.getFullYear();
        const currentMonth = currentDate.getMonth() + 1;

        let financialYear;
        if (currentMonth >= 4) {
            financialYear = `${currentYear}-${String(currentYear + 1).slice(-2)}`;
        } else {
            financialYear = `${currentYear - 1}-${String(currentYear).slice(-2)}`;
        }

        const allEnquiries = await getAllEnquiryTenders();
        const currentFYEnquiries = allEnquiries.filter(enquiry =>
            enquiry.EnquiryNumber && enquiry.EnquiryNumber.includes(`ENQUIRY/${financialYear}/`)
        );

        const maxSerial = currentFYEnquiries.reduce((max, enquiry) => {
            const parts = enquiry.EnquiryNumber.split('/');
            const serial = parseInt(parts[2]) || 0;
            return serial > max ? serial : max;
        }, 0);

        const serialNumber = maxSerial + 1;
        return `ENQUIRY/${financialYear}/${serialNumber}`;
    };

    const handleReset = () => {
        if (props.action === "Edit") {
            setEnquiryObj(props.rowData);
        } else {
            setEnquiryObj({
                EnquirySource: "Manual",
                EnquiryStatus: "Open",
                ItemCode: "",
                ItemDescription: "",
                ItemDetail: "",
                Quantity: "",
                UOM: "",
                GST: "",
                Location: "",
                ImagesAttachment: "",
                ImagesAttachmentFile: null,
                Remarks: "",
                DueDate: "",
                InsertedBy: userDetails.userId,
                InsertedByName: userDetails.userName,
                InsertedOn: todayDate,
                ModifiedBy: userDetails.userId,
                ModifiedByName: userDetails.userName,
                ModifiedOn: todayDate
            });
        }

        setError({
            ItemCode: "",
            ItemDescription: "",
            ItemDetail: "",
            Quantity: "",
            UOM: "",
            GST: "",
            Location: ""
        });
    };

    const handleFileDownload = async (fileName) => {
        try {
            const enquiryNumber = enquiryObj.EnquiryNumber || props.rowData?.EnquiryNumber;
            const filePath = `EnquiryTender/${enquiryNumber.replace(/\//g, '_')}/${fileName}`;
            const downloadURL = await getPresignedURL(filePath);

            if (downloadURL) {
                window.open(downloadURL, '_blank');
            } else {
                MySwal.fire({
                    text: "Unable to download file",
                    imageUrl: errorImage,
                    customClass: "swal-success"
                });
            }
        } catch (error) {
            console.error("Error downloading file:", error);
            MySwal.fire({
                text: "Error downloading file",
                imageUrl: errorImage,
                customClass: "swal-success"
            });
        }
    };

    const setPopUpData = (data) => {
        if (data.name === "Item Master") {
            setEnquiryObj((prevState) => ({
                ...prevState,
                ItemCode: data.result.ItemCode,
                ItemDescription: data.result.ItemDescription,
                ItemType: data.result.ItemType || ""
            }));
        }
    };

    const showPopUp = () => {
        setShowPopup(true);
    };

    return (
        <Modal show={props.show} onHide={props.onHide} size="xl" backdrop="static" centered>
            {loading && <div className="spinner-box"> <Spinner animation="border" className="spinner" /></div>}
            <Modal.Header closeButton>
                <Modal.Title>{props.action} Enquiry/Tender</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form id="enquirytenderform" name="enquirytenderform" autoComplete="off">
                    <Row>
                        <Col lg={4} xs={12}>
                            <Form.Group className="g-input">
                                <div className="d-flex align-items-center">
                                    <Form.Control
                                        id="ItemCode"
                                        type="text"
                                        name="ItemCode"
                                        placeholder=" "
                                        value={enquiryObj.ItemCode}
                                        required
                                        readOnly
                                    />
                                    <Form.Label htmlFor="ItemCode">Item Code </Form.Label>
                                    <BiSelectMultiple
                                        size={20}
                                        onClick={showPopUp}
                                        color="#707070"
                                        style={{ marginLeft: "-2rem", cursor: "pointer" }}
                                        className={props.action === "View" ? "d-none" : ""}
                                    />
                                </div>
                                {/* {error.ItemCode && (
                                    <Form.Text className="text-danger">{error.ItemCode}</Form.Text>
                                )} */}
                            </Form.Group>
                        </Col>
                        <Col lg={4} xs={12}>
                            <Form.Group className="g-input">
                                <Form.Control
                                    id="ItemDescription"
                                    type="text"
                                    name="ItemDescription"
                                    placeholder=" "
                                    value={enquiryObj.ItemDescription}
                                    onChange={handleChange}
                                    required
                                    readOnly={props.action === "View"}
                                />
                                <Form.Label htmlFor="ItemDescription">Item Description <span className="req-input">*</span></Form.Label>
                                {error.ItemDescription && (
                                    <Form.Text className="text-danger">{error.ItemDescription}</Form.Text>
                                )}
                            </Form.Group>
                        </Col>
                        <Col lg={4} xs={12}>
                            <Form.Group className="g-input">
                                <Form.Control
                                    as="textarea"
                                    rows={1}
                                    id="ItemDetail"
                                    name="ItemDetail"
                                    placeholder=" "
                                    value={enquiryObj.ItemDetail}
                                    onChange={handleChange}
                                    required
                                    readOnly={props.action === "View"}
                                />
                                <Form.Label htmlFor="ItemDetail">Item Detail <span className="req-input">*</span></Form.Label>
                                {error.ItemDetail && (
                                    <Form.Text className="text-danger">{error.ItemDetail}</Form.Text>
                                )}
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={4} xs={12}>
                            <Form.Group className="g-input">
                                <Form.Control
                                    id="ItemType"
                                    type="text"
                                    name="ItemType"
                                    placeholder=" "
                                    value={enquiryObj.ItemType}
                                    readOnly
                                />
                                <Form.Label htmlFor="ItemType">Item Type</Form.Label>
                            </Form.Group>
                        </Col>
                        <Col lg={4} xs={12}>
                            <SearchSelect
                                name="Division"
                                label={"Division"}
                                data={divisionList}
                                value={enquiryObj.Division}
                                onChange={handleChange}
                                error={error}
                                setError={setError}
                                required
                                disabled={props.action === "View"}
                            />
                        </Col>
                        <Col lg={4} xs={12}>
                            <SearchSelect
                                name="Location"
                                label={"Location"}
                                data={locationList}
                                valueField="Location"
                                labelField="Location"
                                value={enquiryObj.Location}
                                onChange={handleChange}
                                error={error}
                                setError={setError}
                                required
                                readOnly={props.action === "View"}
                            />
                        </Col>

                    </Row>
                    <Row>
                        <Col lg={4} xs={12}>
                            <Form.Group className="g-input">
                                <Form.Control
                                    id="LogisticCompany"
                                    type="text"
                                    name="LogisticCompany"
                                    placeholder=" "
                                    value={enquiryObj.LogisticCompany}
                                    onChange={handleChange}
                                    required
                                    readOnly={props.action === "View"}
                                />
                                <Form.Label htmlFor="LogisticCompany">Logistic Company <span className="req-input">*</span></Form.Label>
                                {error.LogisticCompany && (
                                    <Form.Text className="text-danger">{error.LogisticCompany}</Form.Text>
                                )}
                            </Form.Group>
                        </Col>
                        <Col lg={4} xs={12}>
                            <Form.Group className="g-input">
                                <Form.Control
                                    id="Quantity"
                                    type="text"
                                    name="Quantity"
                                    placeholder=" "
                                    value={enquiryObj.Quantity}
                                    onChange={handleChange}
                                    required
                                    readOnly={props.action === "View"}
                                />
                                <Form.Label htmlFor="Quantity">Quantity <span className="req-input">*</span></Form.Label>
                                {error.Quantity && (
                                    <Form.Text className="text-danger">{error.Quantity}</Form.Text>
                                )}
                                {/* <Form.Text className="text-muted" style={{fontSize: '11px'}}>Enter numeric value or "As Per Weight"</Form.Text> */}
                            </Form.Group>
                        </Col>
                        <Col lg={4} xs={12} >
                            <SearchSelect
                                name="UOM"
                                label={"UOM"}
                                data={uomList}
                                valueField="UOMCode"
                                labelField="UOMCode"
                                value={enquiryObj.UOM}
                                onChange={handleChange}
                                error={error}
                                setError={setError}
                                required
                                disabled={props.action === "View"}
                            />
                        </Col>
                    </Row>
                    <Row style={{ marginTop: '5px' }}>
                        <Col lg={4} xs={12}>
                            <Form.Group className="g-input">
                                <div className="d-flex align-items-center">
                                    <Form.Control
                                        id="GST"
                                        type="number"
                                        name="GST"
                                        step="0.01"
                                        placeholder=" "
                                        value={enquiryObj.GST}
                                        onChange={handleChange}
                                        required
                                        readOnly={props.action === "View"}
                                    />
                                    <Form.Label htmlFor="GST">GST <span className="req-input">*</span></Form.Label>
                                    <span style={{ marginLeft: "-3rem", fontSize: "21px", fontWeight: "600", color: "#707070" }}>%</span>
                                </div>
                                {error.GST && (
                                    <Form.Text className="text-danger">{error.GST}</Form.Text>
                                )}
                            </Form.Group>
                        </Col>
                        <Col lg={4} xs={12}>
                            <Form.Group className="g-input">
                                <Form.Control
                                    id="DueDate"
                                    type="date"
                                    name="DueDate"
                                    placeholder=" "
                                    value={enquiryObj.DueDate}
                                    onChange={handleChange}
                                    onBlur={handleDateBlur}
                                    min={formatDateYYYY_MM_DD(new Date())}
                                    readOnly={props.action === "View"}
                                />
                                <Form.Label htmlFor="DueDate">Due Date</Form.Label>
                            </Form.Group>
                        </Col>
                        <Col lg={4} xs={12}>
                            <Form.Group className="g-input">
                                <Form.Control
                                    as="textarea"
                                    rows={1}
                                    id="Remarks"
                                    name="Remarks"
                                    placeholder=" "
                                    value={enquiryObj.Remarks}
                                    onChange={handleChange}
                                    readOnly={props.action === "View"}
                                />
                                <Form.Label htmlFor="Remarks">Remarks</Form.Label>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={12} xs={12} style={{ marginTop: '-10px' }}>
                            <Form.Label className="SubHeaderProjectDetails">Images Attachment</Form.Label>
                            <DragDropRender
                                supportedFilesLabel="Supports: JPEG, JPG, PNG, Max File Size – up to 20MB per file"
                                val={enquiryObj.ImagesAttachment}
                                handleChangeEvent={(params) => handleChangeStatus(params, 'ImagesAttachment')}
                                handleDeleteDocEvent={() => handleDeleteDocument('ImagesAttachment')}
                                handleDownloadDocEvent={(fileName) => handleFileDownload(fileName)}
                                action={props.action}
                                disabled={props.action === "View"}
                            />
                        </Col>
                    </Row>
                </Form>
            </Modal.Body>
            {
                props.action === "View" ?
                    <></> :
                    <Modal.Footer>
                        <Button className={props.action === "View" ? "d-none" : "semiBoldToggleButton cancelBtn"} variant="outline-success" onClick={handleReset}>Reset</Button>
                        <Button
                            variant="success"
                            className={props.action === "View" ? "d-none" : "btn-add-color semiBoldToggleButton"}
                            onClick={handleSubmit}
                        >
                            {props.action === "Edit" ? "Update" : "Submit"}
                        </Button>
                    </Modal.Footer>
            }
            {showPopup && (
                <SingleValuePopUp
                    show={showPopup}
                    onHide={() => setShowPopup(false)}
                    setSelected={setPopUpData}
                    mastername="Item Master"
                    paramkey="ItemCode"
                    paramvalue={enquiryObj.ItemCode}
                    backdrop="static"
                />
            )}
        </Modal>
    );
};

export default AddEditEnquiryTender;
